import { render, staticRenderFns } from "./WatchlistDisplayModal.vue?vue&type=template&id=132e405a"
import script from "./WatchlistDisplayModal.vue?vue&type=script&lang=js"
export * from "./WatchlistDisplayModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports